import { useState, useMemo } from "react";
import { cn } from "../../../../../../util/cn";
import CloudSVG from "../../../../../custom-ui/icons/CloudSVG";

type TCancelAnnualPlanModalProps = {
  onSubmit: () => void;
  isCancelPlanDisabled:boolean;
};

const CancelAnnualPlanModal = ({ onSubmit, isCancelPlanDisabled }: TCancelAnnualPlanModalProps) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center overflow-hidden mt-[-90px]",
        {},
      )}
    >
      <div className="mt-[90px] w-[120px] h-[80px] rounded-full bg-[#FFF4E5] flex justify-center items-center">
        <img src="/images/caution.png" />
      </div>
      <div className="flex flex-col gap-[15px] items-center mt-[30px]">
        <p className="w-[360px] font-[Gilroy-Bold] font-[400] text-[30px] leading-[37.14px] text-[#15415E] text-center">
          We’re sorry to see you go!
        </p>

        <p className="w-auto font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[23px] text-[#15415E] text-center">
          To cancel your plan, please contact your account representative.
        </p>
        <p className="w-auto font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[23px] text-[#15415E] text-center">
          💡 Want to explore other options first?
          We’d love to talk about adjusting your plan, pausing instead of cancelling, or finding a better fit for your hiring needs.
        </p>
      </div>

      <div className="flex flex-row justify-center items-center mt-[35px]">
        <button
          className={cn(
            "flex justify-center items-center h-[60px] w-[368px] py-[30px] px-[30px] rounded-[70px] text-[20px] leading-[24.76px] font-[400] font-[Gilroy-Bold]",
            isCancelPlanDisabled
              ? "bg-gray-400 text-[#FFFFFF] cursor-not-allowed"
              : "bg-[#183852] text-[#FFFFFF]"
          )}
          onClick={onSubmit}
        >
          Proceed with <br/> Cancellation Request
        </button>
      </div>
    </div>
  );
};

export default CancelAnnualPlanModal;
